import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { generatePath as _generatePath, matchPath } from 'react-router-dom';
import { store } from 'flow/configure-store';
import { routes } from 'flow/types/routes';

/* Routes that render their own unauthenticated state, so a 401 must not throw the user out. */
export var isUnauthorizedSafePath = function isUnauthorizedSafePath(pathname) {
  return [routes.signin, routes.uaePassCallback].some(function (path) {
    return !!matchPath(pathname, {
      path: path,
      exact: true
    });
  });
};
export var generatePath = function generatePath(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var state = store.getState();
  params = _objectSpread({
    extensionKey: state.app.getIn(['extension', 'key'])
  }, params);
  return _generatePath(path, params);
};